import { FC, SVGProps } from "react";

const DotIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="currentcolor" {...props}>
      <path
        d="M1.29854 1.29961C-0.434101 3.03225 -0.434101 5.84373 1.29854 7.57637L2.4836 8.76143C4.21624 10.4941 7.02772 10.4941 8.76036 8.76143C10.493 7.0288 10.493 4.21733 8.76034 2.48469L7.57528 1.29962C5.84264 -0.433012 3.03117 -0.433027 1.29854 1.29961Z"
      />
    </svg>
  );
};

export default DotIcon;
